var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDocumentsListIcon = function SvgDocumentsListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 18.25H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm0-5H22v2.5H6.5v-2.5zm-4.5 15h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5zm0-5h2.5v2.5H2v-2.5z",
    fill: "#545454"
  }))));
};

export default SvgDocumentsListIcon;